<template>
  <div class="consult">
    <div class="dakuang">
      <div class="yc">
        <div class="bj">
          <img src="../../../static/img/dsds.png" alt="">
          <p>热门文档</p>
        </div>
        <div class="ycnr" v-for="(item,index) in listone" style="cursor:pointer" @click="openNewsDetail(item.newsId,0,42,'zygl')">
          <!-- <img src="../../../static/img/ksbdnr.png" alt=""> -->
          <span class="newtitle" style="width: 240px;font-weight: bold;">{{item.newsTitle}}</span>
          <span class="ss2">{{item.newsReleaseTime}}</span>
          <span class="ss3">{{item.newsClick}}</span>
          <img class="img1" src="../../../static/img/yj.png" alt="">
        </div>
      </div>
      <!-- <div style="width:0px;height:764px;background-color:#F8F8F8;float:right"></div> -->
      <div class="ksbd" v-for="item in newsDan">
        <div class="bj">
          <img src="../../../static/img/ksbd.png" alt="">
          <p>{{item.typeName}}</p>
        </div>
        <div class="ksbdnr" style="width:980px;height:200px;border-top: 1px solid  #E2E2E2;display: flex;justify-content: space-between;" >
          <div class="item" v-for="obj in item.data" @click="openNewsDetail(obj.newsId,0,item.typeId,item.typeParent)" >
            <div class="img" style="width: 100%"><img :src="($resourcesUrl+`${obj.newsImg}`)" alt=""></div>
            <span class="newtitle">{{obj.newsTitle.length>30?obj.newsTitle.substring(0,28+'...'):obj.newsTitle}}</span>
            <div class="time" style="width: 100%">
              <span class="l">{{obj.newsReleaseTime}}</span>
              <div class="r">
                <img class="img1" src="../../../static/img/yj.png" alt="">
                {{obj.newsClick}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid content" style="margin-top:0px" v-for="(item,key,index) in newsZun">
      <div class="head-nav">
        <div class="head-nav-div"><img style="margin-right:10px" src="../../../static/img/yszs.png">{{NEWSPARENT[key]}}
        </div>
        <div
          :class="(navIndex[key]!=null&&navIndex[key].typeId==one.typeId)||(navIndex[key]==null&&i == 0)?'activite':''"
          @click="checkIndex(key,one.typeId)" v-for="(one,k,i) in item"
          style="font-size:20px;color:#F43626;width:80px;padding:0px;margin-right:30px">{{one.typeName}}
        </div>
      </div>
      <div class="container" style="width:1280px" v-for="(one,k,i) in item"
        v-if="(navIndex[key]!=null&&navIndex[key].typeId == one.typeId)||(navIndex[key]== null&&i ==0)">
        <div class="list">
          <div class="item" v-for="(obj,n) in one.data"  @click="openNewsDetail(obj.newsId,0,one.typeId,one.typeParent)">
            <img style="width:100%;height:200px;border-radius: 15px;" :src="($resourcesUrl+`${obj.newsImg}`)" alt="">
            <span class="newtitle">{{obj.newsTitle.length>38?obj.newsTitle.substring(0,35)+'...':obj.newsTitle}}</span>
            <div class="time">
              <div class="l">{{obj.newsReleaseTime}}</div>
              <div class="r"> <img src="../images/home/look.png" alt="">{{obj.newsClick}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- <div class="container-fluid content">
      <div class="head-nav">
        <div class="head-nav-div2"><img style="margin-right:10px" src="../../../static/img/yszs.png">艺术招生</div>
        <div :class="navIndexs==indexs?'activite':''" @click="checkIndexs(indexs)"
          style="font-size:20px;color:#F43626;width:80px;padding:0px;margin-right:30px"
          v-for="(item,indexs) in navLists" :key='indexs'>{{item}}
        </div>
      </div>
      <div class="containers" style="width:1500px;padding-left:10px">
        <div class="lists">
          <div class="items" style="margin:0 5px 0 5px " v-for="(item,index) in this.listss" :key="index"
            @click="wenzhang">
            <img :src="item.image" alt="">
            <div class="texts" style="padding-left:5px">{{item.detail}}</div>
            <div class="times">
              <img src="../../../static/img/sj.png" style="width:10px;height:10px;" alt="">
              <span style="font-size:1px;">{{item.time}}</span>
            </div>
          </div>
        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
  export default {
    props: {
      newsInfo: {
        type: Object
      }
    },
    data() {
      return {
        newsZun: this.newsInfo.newsZun,
        newsDan: this.newsInfo.newsDan,
        NEWSPARENT: {},
        navIndex: {},
        navIndexs: 0,
        listone:[],
        userInfo:this.$utils.getlocalStorage('userInfo')
      }
    },
    methods: {
      openNewsDetail(id,Name,typeid,type){
        let url = this.$router.resolve({
        		path: '/newsDetail',
        		query: {id:id,Name:Name,typeid:typeid,type:type}
        	})
        	window.open(url.href, '_blank')
      },
      getnewsData(){
        let _this = this;
        let query={
            newsTypeId: 42
          }
        if(this.userInfo!=null&&this.userInfo.userProvinces!=""){
          query.newsArea = this.userInfo.userProvinces
        }
        this.$req.queryAllByLimit("newsTable", {
          pageSize: 6,
          pageNum: 1,
          queryObj: query
        }).then(function(response) {
          _this.listone = response.data
        })
      },
      checkIndex(key, typeId) {
        if (this.navIndex[key] == null) {
          this.navIndex[key] = {}
        }
        this.navIndex[key].typeId = typeId;
        this.$forceUpdate();
        console.log(this.navIndex)
      },
      checkListIndex(index) {
        this.listIndex = index;
      },
      checkIndexs(indexs) {
        this.navIndexs = indexs;
        console.log(indexs)
      },
      checkListIndexs(indexs) {
        this.listIndexs = indexs;
      },
      selectClick(item) {
        this.selectList.forEach((item) => {
          item.active = false;
        });
        item.active = true;
      },
      // wenzhang() {
      //   this.$router.push('/ksbdxiangqing')
      // },
      // tiaohzuan() {
      //   this.$router.push('/gaokaozhixun')
      // }
    },
    created() {
      this.NEWSPARENT = this.$utils.getlocalStorage('NEWSPARENT')
      this.newsZun = this.newsInfo.newsZun;
      this.newsDan = this.newsInfo.newsDan;
      this.getnewsData()
    }
  }
</script>

<style>
  .consult>.container-fluid>.head-nav {
    box-shadow: 2px 0px 0px #e0e1e5;
    width: 1280px;
    margin: 0 auto;
    display: flex;
    background-color: white;
    /* justify-content: space-around; */
    box-sizing: border-box;
    align-items: center;
    padding-right: 40px;
    opacity: 1;
    height: 31px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    color: #F43626;
    margin-top: 10px;
  }

  .consult>.container-fluid>.head-nav>.activite {
    font-weight: bold;
    border-bottom: 2px solid red;
    color: red;
    font-size: 20px;
    padding: 0px;
  }

  .consult>.container-fluid>.head-nav>div {
    /* margin: 0 auto; */
    padding-bottom: 10px;
    padding-right: 50px;
    padding-left: 20px;
    margin-top: 20px;
  }

  .consult {
    width: 100%;
  }

  .consult>.dakuang {
    width: 1280px;
    margin: 0 auto;
  }

  .consult>.dakuang>.yc {
    width: 278px;
    /* height: 764px; */
    background-color: white;
    float: right;

  }

  .consult>.dakuang>.yc>.bj {
    width: 278px;
    height: 40px;
    background: linear-gradient(135deg, #F43626 0%, #FF9804 100%);
  }

  .consult>.dakuang>.yc>.bj>img {
    margin-left: 20px;
    margin-top: 10px;
    float: left;
  }

  .consult>.dakuang>.yc>.bj>p {
    width: 100px;
    height: 40px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 40px;
    color: #FFFFFF;
    margin-left: 5px;
    float: left;
    opacity: 1;
  }

  .consult>.dakuang>.yc>.ycnr {
    width: 278px;
    height: 92px;
    background: rgba(255, 255, 255, 0.39);
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
    opacity: 1;
  }

  .consult>.dakuang>.yc>.ycnr>span {
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 15px;
    margin-left: 20px;
    float: left;
    opacity: 1;
    margin-right: 20px;
  }

  .consult>.dakuang>.yc>.ycnr>.ss2 {
    height: 24px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    color: #666666;
    opacity: 1;
    margin-left: 20px;
    opacity: 1;
    margin-top: 5px;
  }

  .consult>.dakuang>.yc>.ycnr>.ss3 {
    height: 24px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    color: #666666;
    opacity: 1;
    margin-left: 5px;
    opacity: 1;
    float: right;
    margin-right: 20px;
    margin-top: 5px;
  }

  .consult>.dakuang>.yc>.ycnr>.img1 {
    width: 20px;
    height: 13px;
    margin-top: 10px;
    float: right;
  }

  .consult>.dakuang>.ksbd {
    width: 980px;
    min-height: 290px;
    background-color: #FFFFFF;
    margin: 0 auto;
    margin-left: 0px;
    margin-bottom: 15px;
    padding-bottom: 15px;
    box-shadow: 1px 1px 1px #e0e1e5;
  }

  .consult>.dakuang>.ksbd>.bj {
    width: 980px;
    height: 40px;
    background: linear-gradient(135deg, #F43626 0%, #FF9804 100%);
    opacity: 1;
    margin: 0 auto;
  }

  .head-nav-div {
    height: 31px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 26px;
    color: #F43626;
    opacity: 1;
  }

  .head-nav-div2 {
    height: 71px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 26px;
    color: #F43626;
    padding-top: 20px;
    opacity: 1;
  }

  .consult>.dakuang>.ksbd>.bj>img {
    margin-left: 20px;
    margin-top: 10px;
    float: left;
  }


  .consult>.dakuang>.ksbd>.bj>p {
    width: 100px;
    height: 40px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 40px;
    color: #FFFFFF;
    margin-left: 5px;
    margin-top: 0px;
    float: left;
    opacity: 1;
  }

  .ksbdnr> .item {
    width: 260px;
    padding: 10px;
    height: 260px;
    cursor : pointer;
  }
  .ksbdnr> .item:hover .newtitle,
  .ycnr:hover .newtitle,
  .container .list .item:hover .newtitle
  {
    color: #409EFF !important;
  }

  .item .iteminfo {
    justify-content: space-between;
    display: flex;
  }

  .consult>.dakuang>.ksbd>.ksbdnr>.item .img img {
    width: 100%;
    height: 160px;
    border-radius: 10px;
  }

  .consult>.dakuang>.ksbd>.ksbdnr>.item>span,
  .container>.list>.item>span
  {
    width: 100%;
    height: 38px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin-top: 5px;
    margin-left: 0px;
    float: left;
    opacity: 1;
  }

  .consult>.dakuang>.ksbd>.ksbdnr>.item>.ss1 {
    width: 100%;
    height: 67px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    color: #666666;
    opacity: 1;
    margin-left: 20px;
    opacity: 1;
    float: left;
    margin-right: 20px;
  }

  .consult>.dakuang>.ksbd>.ksbdnr>.item>.iteminfo>.ss2 {
    width: 100%;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    color: #999999;
    margin-left: 20px;
    margin-top: 10px;
    opacity: 1;
  }

  .consult>.dakuang>.ksbd>.ksbdnr>.item>.img1 {
    width: 20px;
    height: 13px;
    margin-top: 15px;
    float: right;
  }

  .consult>.dakuang>.ksbd>.ksbdnr>.item>.iteminfo>.ss3 {
    width: 25px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    color: #999999;
    margin-left: 5px;
    margin-right: 20px;
    opacity: 1;
    margin-top: 10px;
    float: right;
  }

  .consult>.dakuang>.ksbd>.x {
    width: 1152px;
    height: 0px;
    border: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    background-color: rgba(0, 0, 0, 0.10196078431372549);
    opacity: 1;
    margin: 0 auto;
    margin-top: 205px;
  }

  .consult>.dakuang>.ksbd>.ckgd {
    width: 160px;
    height: 39px;
    border: 1px solid #E23737;
    opacity: 1;
    border-radius: 19px;
    margin: 0 auto;
    margin-top: 20px;
  }

  .consult>.dakuang>.ksbd>.ckgd>p {
    height: 24px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #E23737;
    opacity: 1;
    text-align: center;
    margin-top: 5px;
  }

  .consult>.rmwd {
    width: 298px;
    height: 765px;
    background-color: #FFFFFF;
    float: left;
  }

  .consult>.title {
    width: 393px;
    height: 71px;
    background-image: url("../images/home/titbj.png");
    margin: 0px auto;
    background-size: 100% 100%;
    margin-top: 76px;
    font-size: 48px;
    font-weight: bold;
    text-align: center;
  }

  .consult>.title>.t1 {
    color: #000;
  }

  .consult>.title>.t2 {
    color: #E23737;
  }

  .consult>.tail {
    color: #E2E2E2;
    font-size: 16px;
    text-align: center;
  }

  .consult .select {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .consult .select>.item {
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 1;
    cursor: pointer;
  }

  .consult .select>.item>.icon {
    margin: 39px 0px 36px 0px;
  }

  .consult .select>.item>.icon>img {
    width: 58px;
    height: 62px;
  }

  .consult .select>.item>.text {
    color: #555555;
    font-size: 15px;
  }

  .consult .select>.item>.tail {
    width: 100%;
    height: 19px;
  }

  .consult .select>.item>.tail>img {
    width: 100%;
    height: 19px;
  }

  .consult .content {
    background-color: white;
    padding: 45px 0px;
  }

  .consult .content .container {
    background-color: #FFFFFF;
    padding-bottom: 0px;
    margin-bottom: 15px;
    box-shadow: 1px 2px 1px 2px #e0e1e5;
  }

  .consult .content .list {
    background-color: #ffffff;
    padding: 10px 10px;
    justify-content: space-between;
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;
  }

  .consult .content .list>div
  {
    width: 25%;
    height: 267px;
    margin: 0px;
    padding: 10px;
    cursor: pointer;
    margin-bottom: 15px;
  }

  .consult .content .list>div>img {
    width: 215px;
    margin: 0px;
    height: 128px;
  }

  .consult .content .list>div>.text {
    color: #333;
    font-size: 16px;
  }

  .consult .content .list>div>.time,
  .consult .ksbd .ksbdnr > .item > .time{
    display: flex;
    justify-content: space-between;
    color: #BCBCBC;
    font-size: 14px;
    margin-top: 5px;
    float: left;
    width: 285px;
  }

  .consult .content .list>div>.time>.l,
  .consult .content .list>div>.time>.r,
  .consult .ksbdnr .item .time> .l,
  .consult .ksbdnr .item .time> .r,
  {
    color: #BCBCBC;
    font-size: 14px;
    display: flex;
    align-items: center;
  }

  .consult .content .consultBtn {
    width: 160px;
    height: 39px;
    color: #E23737;
    ;
    border: 1px solid #E23737;
    text-align: center;
    box-sizing: border-box;
    border-radius: 19.5px;
    line-height: 37px;
    cursor: pointer;
    margin: 0px auto;
  }


  .consult .content {
    background-color: #F8F8F8;
    padding: 0px 0px;
    width: 1280px;
  }

  .consult .content .containers {
    background-color: #fff;
    padding-bottom: 20px;
    width: 1170px;
    margin: 0 auto;
  }

  .consult .content .lists {
    background-color: #fff;
    padding: 20px 0px;
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;
  }

  .consult .content .lists>div {
    width: 150px;
    height: 222px;
    margin: 0px;
    margin-bottom: 15px;
  }

  .consult .content .lists>div>img {
    width: 205px;
    margin: 0px 95px 0 5px;
    height: 140px;
    float: left;
  }

  .consult .content .lists>div>.texts {
    color: #333;
    font-size: 16px;
  }

  .consult .content .lists>div>.times {
    float: left;
    color: #BCBCBC;
    font-size: 14px;
    margin-top: 12px;
  }

  .consult .content .lists>div>.times>.ls,
  .consult .content .lists>div>.times>.rs {
    color: #BCBCBC;
    font-size: 10px;
    float: left;
  }

  .consult .content .consultBtns {
    width: 160px;
    height: 39px;
    color: #E23737;
    ;
    border: 1px solid #E23737;
    text-align: center;
    box-sizing: border-box;
    border-radius: 19.5px;
    line-height: 37px;
    cursor: pointer;
    margin: 0px auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/consult.vue